export default {
    page_title: "Kevi | Client Fields",
    title: "Client Fields",
    add_group_button: "Add Group",
    add_field_button: "Add Field",
    empty_group_message: "Drag fields to this group.",

    field_form: {
        title: "Creating field",
        name_label: "Name",
        type_label: "Type",
        back_button: "Back",
        save_button: "Save",
    },

    group_form_modal: {
        title_create: "Create New Group",
        title_edit: "Edit Group",
        name_label: "Group Name",
        name_placeholder: "E.g.: Personal Data",
    },

    confirm_delete_group: {
        title: "Would you like to delete the group",
        body_has_fields:
            "This group contains {0} field(s). Move the fields to another group before deleting.",
        body_no_fields:
            'This action is irreversible. The fields inside it will not be deleted, but moved to the "General" group.',
        attention: "Attention:",
        delete_button: "Delete",
    },

    confirm_delete_field: {
        title: "Would you like to delete",
        body_no_relations:
            "This action is irreversible, are you sure you want to continue?",
        body_linked: "This field is linked to",
        linked_automations: "the following automations:",
        linked_segments: "the following segments:",
        warning_linked:
            "It is recommended to adjust before removing; continuing now may generate unexpected results.",
    },

    confirm_edit_field: {
        title: "Would you like to edit the name to",
        body: "Make sure the new name is correct before confirming.",
    },

    tooltips: {
        edit_group: "Edit group",
        delete_group: "Delete group",
        edit_field: "Edit field",
        delete_field: "Delete field",
        move_field: "Move Field",
    },

    aria: {
        edit_group: "Edit group",
        delete_group: "Delete group",
        confirm_edit: "Confirm edit",
        edit_field: "Edit field",
        delete_field: "Delete field",
        field_name: "Name",
    },

    notifications: {
        field_added: "Field added",
        field_deleted: "Custom field deleted",
        field_edited: "Custom field edited",
        group_created: "Group created",
        group_updated: "Group updated",
        group_deleted: "Group deleted",
        group_name_required: "The group name is required.",
        group_has_fields_error: "Cannot delete a group that contains fields.",
        group_create_error: "Failed to create group.",
        group_update_error: "Failed to update group.",
        group_delete_error: "Failed to delete group.",
        order_saved: "Order saved successfully!",
        order_save_error: "Failed to save the new order.",
    },
};
